import React from 'react';
import { motion } from 'framer-motion';
import { CpuIcon } from 'lucide-react';
import { SlideLayout, itemVariants } from '../ui/SlideLayout';
export function TitleSlide() {
  return <SlideLayout className="text-center relative" hideLogo data-id="element-454">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brand-teal/10 blur-[120px] rounded-full pointer-events-none" data-id="element-455" />

      <motion.div variants={itemVariants} className="flex flex-col items-center justify-center mb-8" data-id="element-456">
        <div className="relative" data-id="element-457">
          <div className="absolute inset-0 bg-brand-teal/20 blur-xl rounded-full" data-id="element-458" />
          <CpuIcon className="w-24 h-24 text-brand-teal relative z-10 mb-6" strokeWidth={1.5} data-id="element-459" />
        </div>
        <h1 className="text-6xl md:text-8xl font-bold text-brand-text tracking-tight mb-4" data-id="element-460">
          OpenFPGA
        </h1>
        <h2 className="text-2xl md:text-3xl text-brand-teal font-medium tracking-wide" data-id="element-461">
          Give your llama wings.
        </h2>
      </motion.div>

      <motion.div variants={itemVariants} className="max-w-3xl mx-auto mb-12" data-id="element-462">
        <p className="text-xl md:text-2xl text-brand-text-dim leading-relaxed" data-id="element-463">
          Better latency, flexible pricing, no vendor lock-in. Access the
          world's most powerful programmable hardware through a single API.
        </p>
      </motion.div>

      <motion.div variants={itemVariants} className="flex items-center justify-center gap-8 text-brand-text-muted font-mono text-sm" data-id="element-464">
        <a href="https://openfpga.ai" className="hover:text-brand-teal transition-colors" data-id="element-465">
          openfpga.ai
        </a>
        <span className="w-1 h-1 rounded-full bg-brand-border" data-id="element-466" />
        <a href="mailto:founders@openfpga.ai" className="hover:text-brand-teal transition-colors" data-id="element-467">
          founders@openfpga.ai
        </a>
      </motion.div>
    </SlideLayout>;
}